import router from "@/router";
import Keycloak from "keycloak-js";
import LoginService from "../LoginService";
import { clearLocalStorage } from "../config";
import { keycloakRest } from "../rest/keycloak.rest";
const login = new LoginService();

export const KeyCloakInstance = new Keycloak({
    url: process.env.VUE_APP_KEYCLOAK_URL,
    realm: process.env.VUE_APP_KEYCLOAK_REALM,
    clientId: process.env.VUE_APP_KEYCLOAK_CLIENT_ID,
});


const Login = (path?: any) => {
    KeyCloakInstance
    .init({
        onLoad: 'login-required',
        checkLoginIframe: true,
        redirectUri: window.location.origin + (path ? path : "/"),
    
    }).then((authenticated) => {
        if(authenticated){
            console.log('Authenticated');
            KeyCloakInstance.authenticated = true;

            login.getUserInfo().then(() => {});

            localStorage.setItem('token', KeyCloakInstance.token as string);
            localStorage.setItem('refreshToken', KeyCloakInstance.refreshToken as string);

        } else {
            console.log('Authenticated failed');
        }

        let tokenParsed = KeyCloakInstance.tokenParsed as any;
        let timeSkew = KeyCloakInstance.timeSkew;

        if(KeyCloakInstance.isTokenExpired(30)){
            KeyCloakInstance.updateToken(30).then((refreshed: boolean) => {
                if(refreshed){
                    console.log("Token refreshed");
                }else{
                    console.log("Token not refreshed, valid for " + Math.round(tokenParsed.exp + timeSkew - new Date().getTime() / 1000) + " seconds");
                }
            }).catch(() => {
                console.error("Failed to refresh token");
                KeyCloakInstance.clearToken();
            })
        }

    }).catch((e) => {
        console.log(e);
        console.log('Authenticated failed', e);
    });
}

const Token = (): string | undefined => KeyCloakInstance?.token;

const Logout = (path?: any) => {
    const keycloakRestService = new keycloakRest();
    keycloakRestService.logoutSession().then(() => {
        clearLocalStorage();
        router.push({ path: path });
    });
}

const refreshToken = () => {
    const keycloakRestService = new keycloakRest();
    keycloakRestService.refreshToken().then((response: any) => {
        console.log("Token refreshed");
        localStorage.setItem('token', response.access_token);
        localStorage.setItem('refreshToken', response.refresh_token);
    }).catch((error: any) => {
        console.log("Failed to refresh token or token is expired");
        if(error.response.status === 400 || error.response.status === 401 || error.response.status === 403){
            KeycloakService.CallLogout("/");
            clearLocalStorage();
        }
    })
}

const IsAuthenticated = (): any => KeyCloakInstance?.authenticated;

const GetLoginUrl = () => KeyCloakInstance.login()

const KeycloakService = {
    CallLogin: Login,
    GetAcessToken: Token,
    CallLogout: Logout,
    IsAuthenticated: IsAuthenticated,
    GetLogURL: GetLoginUrl,
    RefreshToken: refreshToken
}

export default KeycloakService;